import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-create-note',
    templateUrl: './create-note.component.html',
    styleUrl: './create-note.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateNoteComponent implements OnInit {
  private fb = inject(FormBuilder);
  dialogRef = inject<MatDialogRef<CreateNoteComponent>>(MatDialogRef);
  data = inject<{
    note: string;
}>(MAT_DIALOG_DATA);

  createNoteForm: FormGroup;
  note: string;

  constructor() {
    const data = this.data;
 
    this.note = data["note"];
  }

  ngOnInit() {
    this.initializeForm();
  }

  initializeForm(): void {
    this.createNoteForm = this.fb.group({
      note: [this.note??""]
    });
  }

  closeDialog() {
    this.dialogRef.close(true);
  }

  onSubmit(): void {
    if (this.createNoteForm.valid) {
      this.closeDialog();
    } else {
      this.createNoteForm.markAllAsTouched();
    }
  }
}
